<template>
  <div class="page-header page-home">
    <div class="text">
      <div class="title">中国联通客户入网服务协议</div>
      <div v-html="text">{{ text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "unicomDeal1",
  data() {
    return {
      text: "",
    };
  },
  created() {
    this.text = `甲方：
乙方：

    根据《中华人民共和国民法典》《中华人民共和国数据安全法》《中华人民共和国个人信息保护法》《中华人民共和国电信条例》等有关法律法规的规定，甲乙双方在平等、自愿、公平、诚信的基础上，基于对乙方通信服务的了解和需求，甲方自愿申请成为乙方客户，并达成协议如下：
    
    <span style="font-weight: 800;">第一条 入网要求及业务办理</span>
    <span style="font-weight: 800;">（一）甲方不得出租、二次转售、倒卖名下持有的通信卡，如需将通信卡转让给他人使用，应在乙方营业厅办理过户。</span>
    （二）甲方办理入网、变更手续时，应提交以下登记资料：
    1、个人客户：提供个人有效身份证件原件，委托他人办理的应同时提交本人及代理人有效身份证件原件及授权委托书。利用个人临时身份证件原件办理的，须同时提供公安部门出具的身份证领取凭证、身份信息辅助证件（驾照、医保卡或户口本等），不得委托他人办理。
    2、单位客户：提供单位有效证件原件（或加盖公章的单位有效证件复印件）、经办人有效身份证件原件、加盖公章的单位授权书等。单位客户办理移动电话（含无线上网卡）业务时，须同时提供实际使用人有效身份证件。
    3、甲方户籍所在地（以有效身份证件住址为准）或法定住所地（以营业执照所载单位注册地为准）不在本地的，应按照乙方的要求办理相应的担保手续。
    （三）甲方应使用国家给予入网许可标志的终端设备，终端设备应具备支持所选服务的相应功能，如无法支持所选服务，<span style="font-weight: 800;">甲方应自行承担后果，并向乙方全额支付其所选服务的全部费用。</span>
    （四）甲方欲将业务号码过户时，应先交清所有费用，过户时须由双方持有效身份证件原件办理。如有特殊情况，甲方可委托他人办理，但应同时提交本人及代理人有效身份证件原件及授权委托书。
    （五）在甲方通过过户成为新机主的情形下，如因原机主未亲自到场办理过户而导致原机主就此提出异议，甲方应无条件放弃因过户产生的全部权益，并承担由此对原机主及对乙方造成的一切损失。过户代理人对此承担连带责任。
    （六）甲方采用担保人方式入网的，办理过户业务时，甲方须提交担保人出具的书面文件，说明担保人同意继续担保或要求终止担保。新机主应符合本协议第一条第（一、二）款的条件。
    （七）甲方本人未到场，由代理人、经办人办理各类业务的，甲方应承担由此产生的责任与义务；代理人、经办人承担连带责任。
    （八）甲方欲将业务号码办理销户，应先交清所有费用，销户时须持有效身份证件原件办理。如甲方在正式销户后 90 日内未办理销户复装业务，则乙方可在 90 日后重新启用该业务号码。
    
    <span style="font-weight: 800;">第二条 费用标准和费用交纳</span>
    （一）乙方应在国家电信资费主管部门允许的范围内设定资费标准、向客户明码标价、公告交费期限信息；甲方应在乙方明示的期限内足额交纳各项通信费用。
    （二）甲方使用乙方提供的资费套餐方案，套餐有效期为一年（双方特殊约定的除外）。套餐到期后，双方如无异议，有效期逐年自动顺延。如无特殊约定，甲方在有效期内或到期后可更换套餐。
    （三）如遇国家统一调整通信费用标准，则按国家统一规定执行。如遇乙方发布、调整资费，自乙方公告确定的生效日起执行新的资费标准。在乙方公告确定的生效日前，甲方未提出异议的视为同意，协议继续履行；甲方提出异议且未能与乙方达成一致的，甲方向乙方结清全部未付款项后本协议自动终止。
    （四）若甲方为后付费用户，每月 5 日—25 日为支付上月费用的交费期限。甲方应按时交纳通信费用。甲方未在约定期限内足额交纳通信费用的，乙方每日加收所欠费用的３‰作为违约金，并有权暂停甲方服务；甲方交清欠费和违约金后，除甲方明确提出不开通或已销号外，乙方应在 24 小时内恢复甲方服务。对前述情形，乙方将保留追缴欠费、违约金及向征信机构提供用户欠费信息的权利，也可用通知单、委托第三方等形式追缴欠费。
    （五）若甲方为预付费用户，则必须保证账户上有充足的款项。如甲方账户满足消费条件的余额不足，乙方有权限制或停止向甲方提供服务，且乙方可不再另行通知。
    （六）甲方定制第三方增值业务或其它收费业务，乙方可以代第三方向甲方收取信息费、功能费等，甲方使用第三方提供的增值业务或其它收费业务由第三方制定收费标准并公布。
    （七）甲方如需开通国际业务、港澳台业务，应按乙方规定交纳相应费用。
    （八）甲方不应以不知晓终端产生网络流量的原因（例如终端软件自动升级）为由，拒绝支付或要求减免相应费用。

    <span style="font-weight: 800;">第三条 客户权益</span>
    （一）网络服务
    乙方在现有技术条件下和网络覆盖范围内向甲方提供通信服务，并符合国家规定的通信质量标准。甲方理解并认可在现有技术水平、建筑物遮挡、基站周边地形地貌、人为阻拦布置基站等因素影响下，仍然不可避免地存在信号弱或无信号覆盖等情况。
    （二）客户服务
    1、<span style="font-weight: 800;">乙方向甲方提供客户服务电话 10010、网上营业厅 www.10010.com、中国联通 APP 等渠道，以便甲方了解乙方各项服务。</span>乙方还应向甲方免费提供通话所在地（仅限大陆地区，不含港澳台）火警 119、匪警 110、医疗急救 120、交通事故报警 122 等公益性电信服务。
    2、乙方向甲方提供需要甲方支付月功能费的服务项目时，应征得甲方同意；乙方开通服务项目让甲方进行体验时，不收取体验服务项目月功能费。
    3、对于甲方通信服务开通/关闭申请，乙方应在承诺的时限内操作完成（双方另有约定的除外）。乙方超过时限未及时开通/关闭的，应减免超时限后甲方由此产生的通信费用。
    4、甲方个人信息是指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。乙方严格按照《中华人民共和国个人信息保护法》等法律法规的要求，在向甲方提供服务过程中遵循合法、正当、必要和诚信原则，处理甲方个人信息。本协议解除或终止后，乙方不再收集甲方个人信息，并将按照相关法律法规规定对本协议存续期间收集的甲方个人信息进行处理。
    在儿童（指未满 14 周岁的未成年人）使用我们的产品或服务过程中，我们会严格履行法律法规规定的儿童个人信息保护义务与责任，遵循正当必要、知情同意、目的明确、安全保障、依法利用的原则，在征得监护人的同意后收集和使用儿童个人信息。
    <span style="font-weight: 800;">5、甲方理解并同意，乙方可以通过业务受理系统登记、纸质返档，通过网络接收、读取并记录等方式，以提供服务为目的，在业务活动中收集、使用甲方提供的和甲方使用服务过程中形成的个人信息；乙方可以为向甲方提供服务、改进服务质量、提供个性化或定制化产品与服务、评估服务效果、确保产品服务安全性、邀请甲方参与产品服务调查、软件认证或升级目的使用甲方个人信息；乙方有权依法对包含甲方在内的整体用户数据进行分析并加以利用，以便于为甲方提供更好服务。</span>
    <span style="font-weight: 800;">6、甲方理解并同意，乙方的某些服务将由其授权合作伙伴或关联公司提供。乙方可能会与其授权合作伙伴或关联公司共享甲方的某些个人信息，以提供必要的客户服务。乙方确认将依照合法、正当、必要、诚信原则，仅出于在能够实现业务目的最小范围内共享甲方必要的个人信息，且受本协议约定的处理目的的约束。乙方会与其签署相应保密协议，要求其按照乙方要求及相关保密和安全措施处理个人信息。如相关法律法规、监管政策要求或乙方为维护甲方权益认为确有必要时，乙方亦会在将信息提供给授权合作伙伴或关联公司前征得甲方的单独同意。授权合作伙伴或关联公司如要改变个人信息的处理目的，将再次征求甲方的授权同意。</span>
    7、甲方本人持有效证件可通过自有营业厅或乙方指定的其他渠道，对其个人信息进行查询、更正。
    8、乙方依法保证甲方的信息资料安全、通信自由和通信秘密。<span style="font-weight: 800;">但以下情形不应视为乙方违反个人信息保护义务：</span>
    <span style="font-weight: 800;">（1）因追缴欠费需要，向第三方机构和征信机构提供用户个人相应信息及欠费信息的；
    （2）为向甲方提供服务，通过短信、彩信、数字短信、电话、电子邮件、信函、微博、微信等方式向甲方发送业务服务信息或进行互动沟通的；
    （3）为订立、履行与您的合同所必需；
    （4）为履行法定职责或者法定义务所必需；
    （5）为应对突发公共卫生事件，或者紧急情况下为保护您的生命健康和财产安全所必需；
    （6）在合理的范围内处理您自行公开或者其他已经合法公开的个人信息；
    （7）与国家安全、国防安全有关的；
    （8）与公共安全、重大公共利益有关的；
    （9）与犯罪侦查、起诉、审判和判决执行等有关的；
    （10）用于维护所提供的产品或服务的安全稳定运行所必需，例如发现、处置产品或服务的故障；
    （11）法律法规及监管政策规定的其他情形。</span>
    9、乙方非常重视用户的隐私和个人信息保护，并会尽全力保护用户的个人信息安全可靠。关于乙方如何收集、存储、使用、披露和保护甲方的个人信息，详见乙方不时更新、修订并公布的《中国联通用户隐私政策》， 网址为 www.10010.com。

    <span style="font-weight: 800;">第四条 风险与责任</span>
    （一）甲方应保证入网、变更登记资料真实有效、准确完整，并有义务配合乙方对登记资料进行查验。甲方登记资料如有变更，应主动办理变更手续。甲方不得出租、二次转售、倒卖名下持有的通信卡，如需将通信卡转让给他人使用，应在乙方营业厅办理过户。因甲方提供的客户资料不详、不实或变更后未及时通知乙方等原因，使乙方无法向甲方提供服务或甲方无法享受到乙方提供的相关服务，乙方无需向甲方承担任何责任。<span style="font-weight: 800;">如乙方发现因甲方登记资料失实或者甲方未配合及时更正，或乙方发现甲方业务号码存在违法使用、违规外呼、呼叫频次异常、超约定用途使用、违规或违约转让、转租、转售、业务号码被公安机关通报、该号码因上述问题被投诉较多等情况的，乙方有权暂停、终止甲方服务，且乙方无需向甲方承担任何责任。</span>
    <span style="font-weight: 800;">（二）甲方应妥善保管自己的用户号码、通信卡、终端、宽带账号，若发现丢失或被盗用，可及时拨打客户服务电话或到乙方营业网点办理暂时停机或修改账号密码手续；并可向公安机关报案，乙方应配合公安机关调查，但乙方不承担上述情形对甲方所造成的后果；如甲方将名下号码交予他人使用，因此引起的义务与责任仍由甲方承担。</span>
    （三）甲方应妥善管理其服务密码、短信验证码。服务密码、短信验证码是甲方办理业务的重要凭证，甲方入网后应立即修改初始服务密码。<span style="font-weight: 800;">凡使用服务密码、短信验证码定制、变更或终止业务的行为均被视为甲方或甲方授权的行为，因此引起的义务与责任均由甲方承担。</span>
    <span style="font-weight: 800;">（四）乙方按照现有技术标准为甲方提供通信服务，但乙方无法控制第三方利用各种手段从事违法行为等情况的发生，如因第三方的恶意行为造成甲方的损失，乙方对此将不承担相关责任。</span>
    （五）甲方使用固网及宽带业务时，未经有关部门批准许可，不得自行更改其使用性质，不得开设各类服务站点，不得利用计算机互联网络进行任何经营性服务活动，否则乙方有权停止服务，依法追缴各项费用和违约金，并不承担任何责任。
    （六）若非双方另行约定，乙方提供的<span style="font-weight: 800;">宽带接入线路 IP 地址随机分配，</span>并限定<span style="font-weight: 800;">小于等于五个PC 终端</span>（不含手机、pad、路由器）上网使用，超过后乙方有权提醒甲方进行更正，甲方在收到乙方提醒之日起三个工作日未进行更正的，乙方可以采取断网、限速等措施保证乙方合法权益，且未经乙方书面同意，甲方不得私自组网连接其他终端设备。
    <span style="font-weight: 800;">（七）甲方退网时，甲方租赁或乙方免费提供给甲方使用的终端设备，应归还乙方或按照甲乙双方相关约定处理。</span>
    <span style="font-weight: 800;">（八）甲方在欠费情况下，乙方有权拒绝为甲方开办其他业务（含移网、固网、宽带等所有业务），直至甲方补交全部欠费及违约金。</span>
    （九）乙方在受理业务（服务）后，将进行线路资源核查，<span style="font-weight: 800;">对于不具备开通条件的，在乙方告知甲方后，本协议自动终止，乙方退还甲方已交纳费用，但不承担其他责任。</span>
    （十）在固定电话开通并正常使用前（含新装、移机、改号等），甲方不能将已选中号码通知他人或进行宣传，否则由此所造成的后果及损失，由甲方自行承担。
    <span style="font-weight: 800;">（十一）甲方所办理的数据业务上下行速率标称值仅为乙方提供的数据业务上下行速率最高值，乙方不能保证在任何情况下均能达到标称值，甲方对此表示知悉并认可。
    （十二）按照公平使用原则，乙方将对甲方的移动数据流量进行降速或封顶限制。甲方每月的移动数据流量达到降速条件时，乙方可对甲方当月的上网服务降速，次月自动恢复；甲方每月的移动数据流量达到或超出流量封顶额度时，乙方可暂停甲方当月的上网服务，次月自动恢复。</span>
    （十三）甲方未付的通信费用达到信用额度时（信用额度是指用户可以用于透支消费的最高通信费用额度），应及时补充交纳通信费用；当甲方未付的通信费用超过信用额度时，乙方有权暂停甲方网络服务<span style="font-weight: 800;">（超过信用额度停机不受约定交费期限的限制）</span>。
    （十四）甲方发布违法信息、违反公序良俗内容的信息，或未经接收客户同意发布商业广告等其他垃圾信息、拨打骚扰电话等不当行为，以及利用乙方提供的服务从事电信网络诈骗等违法犯罪活动的，乙方有权依据行业主管部门、有关行政机关的指令、客户举报或投诉、乙方相关系统检测，以及乙方制定的为保障公众利益的规范，要求甲方重新进行身份认证，或关闭甲方短信、彩信、语音、流量等通信功能，或暂停直至终止服务，或限制甲方办理新入网等业务，由此造成的后果由甲方承担。
    （十五）因甲方原因造成的通信卡密码丢失、锁卡或被他人获取造成的损失，乙方不承担责任，甲方不能以此为由拒绝按本协议约定支付通信费用。
    （十六）携号转网相关约定：
    1、甲方有权选择并依据《携号转网服务管理规定》申请办理携号转网服务。
    2、办理携号转网过程中，乙方需将必要的甲方个人信息提供给携号转网集中业务管理系统，用于比对携入方和携出方登记的证件信息是否一致。
    3、甲方申请携号转网服务的号码应同时满足以下条件：（1）已在携出方办理真实身份信息登记；（2）号码处于正常使用状态（非挂失、停机等）；（3）与携出方结清申请携号转网号码的已出账电信费用，如有未出账的电信费用（包括但不限于国际漫游费用等），与携出方已约定缴费时间和方式；（4）与携出方无在网约定期限限制的协议，或已解除在网期限限制；（5）申请携号转网的号码距离上次携转时间已满 120 日（自然日）。
    4、因技术与设备等差异，甲方携号转网成功后可能需要自行更换手机。
    5、如甲方使用充值卡在原有卡上预存费用，在携号转网成功后将不能继续使用原有卡上剩余费用。
    6、如甲方从其他网络携号转入乙方网络，甲方在原网络享受的积分、信用度、VIP 级别及各种优惠将不能在乙方网络继续使用。
    <span style="font-weight: 800;">7、如甲方办理携号转网，可能会在启用新卡的时间点和网络切换期间出现短时间的通信异常。
    8、甲方可在办理携号转网业务未整点生效前（乙方营业时间内）撤销携号转网业务申请。</span>
    9、甲方在携号转网成功后仍需与携出方结清通信费用。
    10、如甲方从其他网络携号转入乙方网络，携出方和乙方收到携号转网成功生效结果告知后，网络切换完成。网络切换完成后，甲方在乙方办理的新移动电话卡激活启用，由乙方为甲方提供电信服务。
    11、本协议未约定的携号转网事项，双方按照《携号转网服务管理规定》及双方就携号转网业务签订的具体文件（包括但不限于补充协议、业务受理单等）执行。本协议关于携号转网业务的约定如与《携号转网服务管理规定》及双方携号转网具体文件发生冲突，以《携号转网服务管理规定》和双方携号转网具体文件内容为准。
    <span style="font-weight: 800;">（十七）如果用户号码为重新放号的号码，甲方应自行了解该号码曾捆绑的第三方信息，包括但不限于银行、支付宝、微信、水电煤气缴费等，若需更新捆绑信息应向第三方经营者提出。甲方同时确知乙方无从知晓且无权解除号码合法使用人与第三方服务机构之间的号码绑定约定。</span>如甲方不再使用该号码，应当提前解除号码曾捆绑过的第三方信息，否则造成信息泄露或经济损失，由甲方自行承担责任，与乙方无关。如甲方选择使用重新放号号码，将需承担因此种绑定可能产生的不利后果，乙方无法预知上述可能后果且不因此承担相应责任。

    <span style="font-weight: 800;">第五条 违约责任</span>
    （一）一方违约给对方造成损失的，应当依法承担赔偿责任，但违约方应承担的赔偿损失的责任范围不包括守约方未实现的预期利润或利益、商业信誉的损失、丢失的数据本身及因数据丢失引起的损失、守约方对第三方的责任及其他间接损失。
    （二）因不可抗力导致本协议部分或全部不能履行的，双方可部分或全部免除责任。

    <span style="font-weight: 800;">第六条 协议的变更与解除</span>
    （一）乙方在本协议外以公告、使用手册、资费单页等书面形式公开做出的服务承诺，甲方办理各类业务所签署的表单、业务协议、须知等经甲方签署后均成为本协议的补充协议；与本协议冲突部分以补充协议为准，补充协议中未约定部分以本协议为准。
    <span style="font-weight: 800;">（二）甲方要求终止服务（双方另有约定的除外）申请办理拆机或销户的，若甲方为后付费且申请办理拆机或销户时当月的应付费用未出账，或甲方为预付费但预存费用可能不足以支付当月应付费用的，则应按照乙方要求预存一定数额的通信费，次月按照乙方业务规定和双方约定结清相关费用后如有剩余的，乙方将剩余费用退还甲方。
    （三）有下列情形之一的，乙方有权单方解除协议，收回号码或账号并终止服务，并保留追究甲方违约责任的权利：
    1、甲方提供的有效证件（包括代理人/经办人提供的有效身份证件）虚假、不实；
    2、甲方自行安装未取得入网许可或可能影响网络安全或网络服务质量设备的；
    3、甲方以担保等方式取得号码使用权的，如担保人违反保证条款或有确切证据证明担保人无能力履行保证责任的；
    4、甲方未办理相关手续，自行改变电信业务使用性质或私自转让租用权的；
    5、甲方欠费停机后 3 个月仍未交清通信费用和违约金的;
    6、业务（服务）超过约定有效期的；
    7、该号码被国家司法机关认定用于违法犯罪活动或其它不当用途的；
    8、乙方收到国家行政管理部门通知要求停止甲方服务的；
    9、预付费产品在约定期限内未激活的；
    10、违规外呼、呼叫频次异常的；
    11、法律法规规定的其他情形。</span>
    （四）因技术进步或国家政策等原因导致本协议（部分或全部）无法继续履行的，乙方保留对电信业务（服务）做出调整的权利，调整前乙方应按照有关规定发布公告并提出相应解决方案。<span style="font-weight: 800;">甲方可就解决方案与乙方协商，但不得要求乙方继续履行本协议。</span>

    <span style="font-weight: 800;">第七条 争议解决方式</span>
    有关协议争议，双方可沟通协商解决；协商不成的，甲方可向当地通信管理局或消费者协会申请进行调解；任何一方均可向乙方住所地的人民法院起诉。

    <span style="font-weight: 800;">第八条 协议生效</span>
    本协议一式两份，甲乙双方各执一份，自双方签字盖章之日起生效，有效期一年。协议到期后，双方如无异议，有效期以一年为周期自动顺延。`;
  },
};
</script>

<style lang="scss" scoped>
.page-home {
  width: 100%;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;

  .text {
    padding: 1rem;
    font-size: 1rem;
    line-height: 1.5rem;
    white-space: pre-wrap;
    .title {
      font-weight: 800;
      text-align: center;
      margin: 1rem auto;
    }
  }
}
</style>
